/**
 * Quiz and Survey Master - Show Feedback Immediately on Answer Selection
 * 1. User selects answer → popup appears immediately with correct/incorrect info
 * 2. Answers are locked (no going back)
 * 3. User clicks SUIVANT (or SUBMIT on last question) inside popup to proceed
 */

(function ($) {
  'use strict';

  const QuizFeedback = {
    feedbackVisible: false,
    feedbackShownForThisQuestion: false,
    overlayElement: null,
    processingSelection: false,

    init() {
      $(document).ready(() => {
        this.setupListeners();
      });
    },

    isLastQuestion() {
      // On the last question, QSM shows the submit button and hides SUIVANT
      const $suivant = $('.qsm-next.qmn_btn.mlw_next.mlw_custom_next');
      const $submit = $(
        'input[type="submit"].qsm-submit-btn, input[type="submit"].qmn_btn'
      );

      const suivantHidden =
        $suivant.length === 0 ||
        $suivant.css('display') === 'none' ||
        $suivant.is(':hidden');

      const submitExists = $submit.length > 0;

      return suivantHidden && submitExists;
    },

    setupListeners() {
      // Hide feedback that QSM might inject before user selects
      const observer = new MutationObserver(() => {
        if (!this.feedbackShownForThisQuestion) {
          const $feedback = $('.quick-question-res-p:visible');
          if ($feedback.length > 0) $feedback.hide();

          const $inlineInfo = $('.qsm-inline-correct-info:visible');
          if ($inlineInfo.length > 0) $inlineInfo.hide();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class'],
      });

      // === TRIGGER POPUP IMMEDIATELY ON ANSWER SELECTION ===
      $(document).on(
        'change',
        'input[type="radio"], input[type="checkbox"], select',
        () => {
          if (this.feedbackShownForThisQuestion || this.processingSelection)
            return;
          this.processingSelection = true;

          setTimeout(() => {
            this.showFeedbackPopup();
            this.processingSelection = false;
          }, 100);
        }
      );

      // === SUIVANT BUTTON HANDLING (non-last questions) ===
      $(document).on(
        'click',
        '.qsm-next.qmn_btn.mlw_next.mlw_custom_next',
        (e) => {
          if (this.feedbackShownForThisQuestion) {
            // Close popup and let QSM advance naturally
            $('.quick-question-res-p').hide();
            this.hideOverlay();
            this.feedbackVisible = false;
            this.feedbackShownForThisQuestion = false;
            this.processingSelection = false;
            this.unlockAnswers();
            return; // allow click to propagate
          }

          // Block if no answer selected yet
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }
      );
    },

    showFeedbackPopup() {
      if (this.feedbackShownForThisQuestion) return;

      const $feedback = $('.quick-question-res-p');
      if ($feedback.length === 0) return;

      // Inject inline correct/incorrect info
      const $questionPage = $feedback.closest('.qsm-question-page:visible');
      if ($questionPage.length > 0) {
        const $inlineInfo = $questionPage
          .find('.qsm-inline-correct-info')
          .first();
        if ($inlineInfo.length > 0) {
          $feedback.find('.qsm-inline-correct-info').remove();
          $inlineInfo.show();
          $feedback.append($inlineInfo);
          $feedback.find('a').attr('target', '_blank');
        }
      }

      // Remove any previously injected action button from feedback
      $feedback.find('.qsm-feedback-action-btn').remove();

      if (this.isLastQuestion()) {
        // --- LAST QUESTION: inject a working Submit button proxy ---
        const $realSubmit = $(
          'input[type="submit"].qsm-submit-btn, input[type="submit"].qmn_btn'
        ).first();

        const $submitProxy = $('<button>', {
          type: 'button',
          class: 'qsm-btn qsm-feedback-action-btn qsm-submit-proxy qmn_btn',
          text: $realSubmit.val() || 'Submit',
        });

        $submitProxy.on('click', () => {
          $feedback.hide();
          this.hideOverlay();

          // Re-enable all inputs so the form submits with full data (including nonce)
          this.unlockAnswers();

          // Submit the parent form directly
          $realSubmit.closest('form').trigger('submit');
        });

        $feedback.append($submitProxy);
      } else {
        // --- NORMAL QUESTION: inject cloned SUIVANT button ---
        const $nextButton = $('.qsm-next.qmn_btn.mlw_next.mlw_custom_next')
          .first()
          .clone()
          .addClass('qsm-feedback-action-btn');
        $feedback.append($nextButton);
      }

      // Lock answers
      this.lockAnswers();

      // Show overlay + popup
      this.showOverlay();
      $feedback.show();
      this.feedbackVisible = true;
      this.feedbackShownForThisQuestion = true;
    },

    showOverlay() {
      this.overlayElement = document.createElement('div');
      this.overlayElement.className = 'quiz-feedback-overlay';
      document.body.appendChild(this.overlayElement);
    },

    closeFeedback() {
      $('.quick-question-res-p').hide();
      this.hideOverlay();
      this.feedbackVisible = false;
    },

    hideOverlay() {
      if (this.overlayElement) {
        this.overlayElement.remove();
        this.overlayElement = null;
      }
    },

    lockAnswers() {
      $('input, select, textarea')
        .prop('disabled', true)
        .css('opacity', '0.5')
        .css('cursor', 'not-allowed');

      $('input[type="radio"], input[type="checkbox"]')
        .closest('label')
        .css('opacity', '0.5')
        .css('cursor', 'not-allowed');
    },

    unlockAnswers() {
      $('input, select, textarea')
        .prop('disabled', false)
        .css('opacity', '1')
        .css('cursor', 'pointer');

      $('input[type="radio"], input[type="checkbox"]')
        .closest('label')
        .css('opacity', '1')
        .css('cursor', 'pointer');
    },
  };

  QuizFeedback.init();
})(jQuery);
